<template lang="pug">
.text_box
  .logo_box(v-if="data.logo")
    img.logo_img(:src="data.logo")

  h2.questions_title {{ localizedName }}

  .item(
    v-for="(item, index) in answerList"
    :key="index"
    :class="{ 'selected': showSelectedClass(index) }"
    @click="submit(index, item)"
  ) {{ item.name }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object
  },

  computed: {
    /**
     * @returns {Boolean} Multi choice type or not
     */
    /**
     * @returns {Boolean} 是否为多选类型
     */
    isMultiple() {
      return this.data?.settings?.survey?.questionType === 'multiple'
    },
    localizedName() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'displayName') || getLocalizedCampaignField(this.data, 'name') || this.data?.name || ''
    },
  }
})

class textComponents extends Vue {
  selected = null
  selectedList = []
  // answerList = this.data?.settings?.survey?.answerList ?? 0

  /**
   * Show Selected Option Styles
   * @param {Number} index Selected option subscript
   * @returns {Boolean} Whether to display
   */
  /**
   * 显示选中选项样式
   * @param {Number} index 选中的选项下标
   * @returns {Boolean} 是否显示样式
   */
  showSelectedClass(index) {
    // 是否通过条件
    let pass = false
    // Multiple choice or not
    // 是否多选
    if (this.isMultiple) {
      pass = this.selectedList.findIndex(item => item === index) > -1
    } else {
      pass = this.selected === index
    }
    return pass
  }

  get answerList() {
    let answerList = this.data?.settings?.survey?.answerList ?? []
    // Reconstruct the format of the unified answerList
    // 重构统一 answerList 的格式
    if (typeof answerList[0] === 'string') answerList = answerList.map(item => ({ name: item, value: item }))
    return answerList
  }

  /**
   * 提交选中选项信息
   * @param {Number} index 选中选项在列表中的下标
   * @param {Object} item 选中选项的信息
   */
  submit(index, item) {
    if (this.isMultiple) { // If multiple choices   // 若是多选
      // Whether the currently selected option has been selected
      // 当前选择的选项是否已被选中
      const hasSelectedIndex = this.selectedList.findIndex(selected => selected === index)
      if (hasSelectedIndex < 0) { // If not in the selected list, add this option   // 已选列表中没有，则添加该选项
        this.selectedList.push(index)
      } else { // If it is present in the selected list, remove the option from the list   // 已选列表中存在，则从列表中删除该选项
        this.selectedList.splice(hasSelectedIndex, 1)
      }
      const valueList = []
      // Get the value list according to the hit list
      // 根据已中列表，得出 value 列表
      this.selectedList.map(selectedIndex => {
        const answer = this.answerList[selectedIndex]
        if (answer.value) valueList.push(answer.value)
      })
      if (valueList.length === 1) {
        // If the array has only one value, the string type is passed
        // 若数组只有一个值时，传字符串类型
        this.$emit('event', valueList[0]) // Expose click events   // 暴露点击事件
      } else {
        this.$emit('event', valueList) // Expose click events   // 暴露点击事件
      }
    } else { // If single choice   // 若是单选
      this.selected = index
      const { value, campaign } = item
      this.$emit('event', value, campaign) // Expose click events   // 暴露点击事件
    }
  }

  _initializationData() {
    this.selected = null
  }
}

export default textComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *
.text_box
  padding: 0 16px 20px

  .questions_title
    font-weight: bold

  .item
    margin-bottom: 10px

    &:last-child
      margin: 0
</style>
